/* ============ BOREDUMB — Shopify theme interactions ============ */
(function(){
  /* ---------- motion ---------- */
  function getMotion(){ return document.body.dataset.motion || 'playful'; }

  /* ---------- safety: remove any leftover splash screen + unlock scroll ---------- */
  (function(){ const s = document.getElementById('splash'); if(s) s.remove(); document.body.style.overflow = ''; })();

  /* ---------- ambient gooey blobs ---------- */
  function placeBlobs(container, specs){
    if(!container) return;
    container.innerHTML = '';
    specs.forEach((s, i) => {
      const b = document.createElement('span');
      b.style.left = s.x; b.style.top = s.y; b.style.width = s.d; b.style.height = s.d;
      b.style.animation = (i%2 ? 'floatB':'floatA') + ' var(--float-dur) ease-in-out infinite';
      b.style.animationDelay = (-i*1.3)+'s';
      container.appendChild(b);
    });
  }
  /* ---------- draggable gooey hero blobs (touch + mouse, inertia, soft walls) ---------- */
  function makeDraggableBlobs(container, specs, opts){
    opts = opts || {};
    if(!container) return;
    container.innerHTML = '';
    const motionOf = () => (document.body.dataset.motion || 'playful');
    const ambScale = { off:0, calm:0.5, playful:1, chaotic:1.9 };
    let rect = container.getBoundingClientRect();

    const blobs = specs.map((s) => {
      const el = document.createElement('span');
      const d = parseFloat(s.d);
      el.style.width = d+'px'; el.style.height = d+'px';
      el.style.left = '0'; el.style.top = '0';
      el.style.touchAction = 'none';
      el.style.cursor = 'grab';
      container.appendChild(el);
      const b = {
        el, r: d/2,
        x: parseFloat(s.x)/100 * rect.width,
        y: parseFloat(s.y)/100 * rect.height,
        vx: 0, vy: 0, px: 0, py: 0, lx: 0, ly: 0, lt: 0, held: false, woke: false,
        f1: 0.16 + Math.random()*0.28, f2: 0.12 + Math.random()*0.24, ph: Math.random()*Math.PI*2
      };
      el.addEventListener('pointerdown', e => {
        rect = container.getBoundingClientRect();
        b.held = true; b.woke = true; el.style.cursor = 'grabbing';
        b.dcx = e.clientX; b.dcy = e.clientY;
        const cx = e.clientX - rect.left, cy = e.clientY - rect.top;
        b.px = b.x - cx; b.py = b.y - cy;
        b.lx = cx; b.ly = cy; b.lt = performance.now(); b.vx = b.vy = 0;
        try { el.setPointerCapture(e.pointerId); } catch(_){}
      });
      el.addEventListener('pointermove', e => {
        if(!b.held) return;
        const cx = e.clientX - rect.left, cy = e.clientY - rect.top;
        b.x = cx + b.px; b.y = cy + b.py;
        const now = performance.now(), dt = Math.max(8, now - b.lt);
        b.vx = (cx - b.lx) / dt * 16; b.vy = (cy - b.ly) / dt * 16;
        b.lx = cx; b.ly = cy; b.lt = now;
      });
      const release = e => {
        if(!b.held) return;
        b.held = false; el.style.cursor = 'grab';
        try { el.releasePointerCapture(e.pointerId); } catch(_){}
        const max = 34;
        b.vx = Math.max(-max, Math.min(max, b.vx)); b.vy = Math.max(-max, Math.min(max, b.vy));
        const moved = Math.hypot((e.clientX||b.dcx) - b.dcx, (e.clientY||b.dcy) - b.dcy);
        if(opts.onTap && moved < 6) opts.onTap();
      };
      el.addEventListener('pointerup', release);
      el.addEventListener('pointercancel', release);
      el.addEventListener('click', ev => ev.stopPropagation());
      return b;
    });

    let t0 = performance.now();
    function tick(now){
      if(!container.isConnected) return;
      const dt = Math.min(2.2, (now - t0)/16.67); t0 = now;
      const amp = ambScale[motionOf()] ?? 1;
      const W = rect.width, H = rect.height;
      for(const b of blobs){
        if(!b.held){
          if(amp > 0){
            const tt = now/1000;
            const live = b.woke ? 1 : 0.28;   // calmer until first drag
            b.vx += Math.sin(tt*b.f1 + b.ph) * 0.042 * amp * live * dt;
            b.vy += Math.cos(tt*b.f2 + b.ph*1.7) * 0.042 * amp * live * dt;
          }
          b.vx *= 0.96; b.vy *= 0.96;
          b.x += b.vx * dt; b.y += b.vy * dt;
          const pad = b.r*0.4;
          if(b.x < pad){ b.x = pad; b.vx = Math.abs(b.vx)*0.5; }
          if(b.x > W-pad){ b.x = W-pad; b.vx = -Math.abs(b.vx)*0.5; }
          if(b.y < pad){ b.y = pad; b.vy = Math.abs(b.vy)*0.5; }
          if(b.y > H-pad){ b.y = H-pad; b.vy = -Math.abs(b.vy)*0.5; }
        }
        const sc = b.held ? 1.08 : 1;
        b.el.style.transform = `translate(${b.x-b.r}px, ${b.y-b.r}px) scale(${sc})`;
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
    window.addEventListener('resize', () => { rect = container.getBoundingClientRect(); });
  }
  makeDraggableBlobs(document.querySelector('.hero-goo'), [
    {x:'14%',y:'22%',d:'160px'},{x:'80%',y:'28%',d:'210px'},{x:'66%',y:'68%',d:'120px'},{x:'22%',y:'72%',d:'150px'},{x:'46%',y:'14%',d:'90px'},{x:'88%',y:'72%',d:'80px'}
  ]);

  /* ---------- re-honor #hash after layout settles (images, reveals, splash) ---------- */
  function rehonorHash(){
    var h = location.hash;
    if(!h || h === '#') return;
    var t; try { t = document.querySelector(h); } catch(e){ return; }
    if(!t) return;
    // derive the landing offset straight from CSS so it always matches native anchor scroll
    var sp = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
    var sm = parseFloat(getComputedStyle(t).scrollMarginTop) || 0;
    var top = sp + sm;
    requestAnimationFrame(function(){
      var y = t.getBoundingClientRect().top + window.scrollY - top;
      window.scrollTo(0, Math.max(0, Math.round(y)));
    });
  }
  window.addEventListener('load', function(){
    if(location.hash) setTimeout(rehonorHash, 60);
  });

  /* ---------- marquee ---------- */
  document.querySelectorAll('.marquee-track').forEach(tr => { tr.innerHTML = tr.innerHTML + tr.innerHTML; });

  /* ---------- scroll reveal (bulletproof) ---------- */
  function revealInView(){
    const vh = window.innerHeight || document.documentElement.clientHeight;
    document.querySelectorAll('.reveal:not(.in)').forEach(el => {
      const r = el.getBoundingClientRect();
      if(r.top < vh * 0.92 && r.bottom > 0) el.classList.add('in');
    });
  }
  window.addEventListener('scroll', revealInView, { passive: true });
  window.addEventListener('resize', revealInView);
  window.addEventListener('load', revealInView);
  revealInView();
  setTimeout(revealInView, 1200);

  /* ---------- toast ---------- */
  let toastEl;
  function toast(msg, href){
    if(!toastEl){ toastEl = document.createElement('div'); toastEl.id = 'bd-toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.style.cursor = href ? 'pointer' : '';
    toastEl.onclick = href ? function(){ window.location.href = href; } : null;
    toastEl.classList.add('show');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(()=> toastEl.classList.remove('show'), href ? 3400 : 2000);
  }

  /* ---------- live bag count (Shopify) ---------- */
  async function refreshCart(){
    try{
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      document.querySelectorAll('[data-bag-count]').forEach(el => el.textContent = cart.item_count);
    }catch(e){}
  }

  /* ---------- money (basic; assumes 2 decimals) ---------- */
  function money(cents){
    const sym = '$';
    return sym + (cents/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ---------- PRODUCT PAGE ---------- */
  const pdp = document.getElementById('pdp');
  if(pdp){
    let variants = [];
    try { variants = JSON.parse(document.getElementById('pdp-variants').textContent); } catch(e){}
    const variantInput = document.getElementById('variant-id');
    const priceEl = document.getElementById('pdp-price');
    const addBtn = document.getElementById('pdp-add');
    const qtyInput = document.getElementById('quantity-input');
    const qtyDisp = pdp.querySelector('[data-qty]');

    function selectedValues(){
      const groups = [...pdp.querySelectorAll('[data-opt-index]')]
        .sort((a,b)=> a.dataset.optIndex - b.dataset.optIndex);
      return groups.map(g => { const on = g.querySelector('.is-on'); return on ? on.dataset.value : null; });
    }
    function findVariant(vals){
      return variants.find(v => v.options.every((o,i)=> vals[i]==null || o === vals[i]));
    }
    function syncVariant(){
      const v = findVariant(selectedValues());
      if(!v) return;
      variantInput.value = v.id;
      if(priceEl) priceEl.textContent = money(v.price);
      const lab = pdp.querySelector('[data-color-label]');
      const vals = selectedValues();
      if(lab){ const ci = [...pdp.querySelectorAll('.swatches')][0]; if(ci){ const idx = +ci.dataset.optIndex; if(vals[idx]) lab.textContent = vals[idx]; } }
      if(addBtn){
        if(v.available){ addBtn.disabled = false; addBtn.textContent = 'Add to Cart — ' + money(v.price); }
        else { addBtn.disabled = true; addBtn.textContent = 'Sold Out'; }
      }
    }
    pdp.querySelectorAll('[data-opt-index]').forEach(group => {
      group.querySelectorAll('.size-btn, .sw').forEach(btn => btn.addEventListener('click', () => {
        group.querySelectorAll('.size-btn, .sw').forEach(b => b.classList.remove('is-on'));
        btn.classList.add('is-on'); syncVariant();
      }));
    });

    // qty
    pdp.querySelectorAll('[data-qstep]').forEach(b => b.addEventListener('click', () => {
      let q = Math.max(1, parseInt(qtyInput.value||'1',10) + parseInt(b.dataset.qstep,10));
      qtyInput.value = q; if(qtyDisp) qtyDisp.textContent = q;
    }));

    // thumbnails
    const mainImg = document.getElementById('pdp-main-img');
    pdp.querySelectorAll('.pdp-thumb').forEach(t => t.addEventListener('click', () => {
      pdp.querySelectorAll('.pdp-thumb').forEach(x => x.classList.remove('is-on'));
      t.classList.add('is-on');
      if(mainImg && t.dataset.img) mainImg.src = t.dataset.img;
    }));

    // accordions
    pdp.querySelectorAll('.acc-head').forEach(h => h.addEventListener('click', () => h.parentElement.classList.toggle('open')));

    // add to cart (AJAX)
    const form = document.getElementById('product-form');
    if(form){
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const id = variantInput.value;
        const qty = parseInt(qtyInput.value||'1',10);
        if(!id){ toast('Pick a size first'); return; }
        addBtn.disabled = true;
        try{
          const res = await fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept':'application/json' },
            body: JSON.stringify({ id: id, quantity: qty })
          });
          if(!res.ok){ const err = await res.json(); toast(err.description || 'Could not add to cart'); }
          else { toast('Added to Cart', '/cart'); await refreshCart(); }
        }catch(err){ toast('Could not add to cart'); }
        addBtn.disabled = false;
      });
    }
    syncVariant();
  }

  /* ---------- CART PAGE qty steppers (submit native cart form) ---------- */
  document.querySelectorAll('.cart-form [data-cstep]').forEach(btn => btn.addEventListener('click', () => {
    const row = btn.closest('.qty');
    const input = row.querySelector('[data-cqty]');
    let q = Math.max(0, parseInt(input.value||'0',10) + parseInt(btn.dataset.cstep,10));
    input.value = q;
    const form = btn.closest('.cart-form');
    const upd = form.querySelector('[name="update"]');
    if(upd) upd.click();
  }));

  /* ---------- magnetic blob buttons (desktop) ---------- */
  const fine = window.matchMedia('(pointer:fine)').matches;
  if(fine){
    document.querySelectorAll('.blob-btn').forEach(btn => {
      btn.addEventListener('mousemove', e => {
        if(getMotion()==='off') return;
        const r = btn.getBoundingClientRect();
        const mx = (e.clientX - r.left - r.width/2) / r.width;
        const my = (e.clientY - r.top - r.height/2) / r.height;
        btn.style.transform = 'translate(' + (mx*8) + 'px,' + (my*8) + 'px) scale(1.04)';
      });
      btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
    });
  }

  /* ---------- cursor goo trail ---------- */
  let gooLayer = document.getElementById('goo-layer');
  let trail = [], rafOn = false, mouse = {x:-200,y:-200};
  function setupGooLayer(){
    const m = getMotion();
    const on = false;   // cursor goo trail disabled — replaced by the custom clay cursor
    if(!gooLayer) return;
    if(on){
      if(trail.length===0){
        const n = m==='chaotic' ? 5 : 3;
        for(let i=0;i<n;i++){ const s=document.createElement('span'); const d=26-i*4; s.style.width=d+'px'; s.style.height=d+'px'; gooLayer.appendChild(s); trail.push({el:s,x:mouse.x,y:mouse.y}); }
      }
      gooLayer.style.display='block'; if(!rafOn){ rafOn=true; loop(); }
    } else { gooLayer.style.display='none'; gooLayer.innerHTML=''; trail=[]; rafOn=false; }
  }
  function loop(){
    if(!rafOn) return;
    let px=mouse.x, py=mouse.y;
    trail.forEach((t,i)=>{
      t.x += (px - t.x) * (0.35 - i*0.04); t.y += (py - t.y) * (0.35 - i*0.04);
      t.el.style.transform = 'translate(' + (t.x - parseFloat(t.el.style.width)/2) + 'px,' + (t.y - parseFloat(t.el.style.height)/2) + 'px)';
      px = t.x; py = t.y;
    });
    requestAnimationFrame(loop);
  }
  window.addEventListener('mousemove', e => { mouse.x=e.clientX; mouse.y=e.clientY; });

  /* ---------- share button ---------- */
  const shareBtn = document.getElementById('shareBtn');
  if(shareBtn){
    shareBtn.addEventListener('click', async () => {
      const url = location.href.split('#')[0];
      const data = { title: 'Boredumb', text: 'Cancer is a Business, Not a Disease.', url };
      if(navigator.share){
        try { await navigator.share(data); } catch(e){ /* cancelled */ }
      } else {
        try { await navigator.clipboard.writeText(url); toast('Link copied'); }
        catch(e){ toast(url); }
      }
    });
  }

  /* ---------- mobile menu ---------- */
  const menuBtn = document.querySelector('.menu-btn');
  const navEl = document.querySelector('header.nav');
  if(menuBtn && navEl){
    menuBtn.addEventListener('click', () => navEl.classList.toggle('open'));
    // close the menu after tapping any nav link (incl. same-page anchors)
    navEl.querySelectorAll('.nav-links a').forEach(a => a.addEventListener('click', () => navEl.classList.remove('open')));
  }

  /* ---------- earthy clay/rock "knock" on key actions (Web Audio, no files) ---------- */
  let _actx;
  function knock(){
    if(getMotion()==='off') return;            // stay silent in quiet mode
    try{
      _actx = _actx || new (window.AudioContext || window.webkitAudioContext)();
      const ac = _actx;
      if(ac.state === 'suspended') ac.resume();
      const out = ac.createGain(); out.gain.value = 0.9; out.connect(ac.destination);
      const sr = ac.sampleRate;

      // one tiny grain — a dry, high, super-short tick (a single pebble / clay bit)
      function grain(t, g){
        const dur = 0.018 + Math.random()*0.014;       // 18–32ms, very short
        const buf = ac.createBuffer(1, Math.floor(sr*dur), sr), d = buf.getChannelData(0);
        for(let i=0;i<d.length;i++){ d[i] = (Math.random()*2-1) * Math.pow(1 - i/d.length, 5); }
        const src = ac.createBufferSource(); src.buffer = buf;
        const bp = ac.createBiquadFilter(); bp.type = 'bandpass';
        bp.frequency.value = 1050 + Math.random()*1500; // bright, scattered pitch
        bp.Q.value = 3 + Math.random()*4;               // resonant = "ticky", pitched
        const hp = ac.createBiquadFilter(); hp.type = 'highpass'; hp.frequency.value = 550;
        const ng = ac.createGain();
        ng.gain.setValueAtTime(0.0001, t);
        ng.gain.exponentialRampToValueAtTime(g, t + 0.001);
        ng.gain.exponentialRampToValueAtTime(0.0001, t + dur);
        src.connect(bp).connect(hp).connect(ng).connect(out);
        src.start(t); src.stop(t + dur + 0.01);
      }

      // a little scatter of pebbles landing close together
      const t0 = ac.currentTime;
      const n = 4 + Math.floor(Math.random()*3);        // 4–6 tiny hits
      for(let i=0;i<n;i++){
        const t = t0 + (i===0 ? 0 : i*0.03 + Math.random()*0.045);
        grain(t, (0.32 + Math.random()*0.4) * (i===0 ? 1 : 0.8));
      }
    }catch(e){}
  }
  // fire only on: home hero Shop, home product CTAs, Add to Cart, Buy Now
  ['.hero-cta .blob-btn', '.pf-cta .blob-btn', '#pdp-add', '#pdp-buy'].forEach(sel => {
    document.querySelectorAll(sel).forEach(el => el.addEventListener('click', knock));
  });
  // empty-cart Shop button navigates away — play the sound first, then follow the link
  document.querySelectorAll('.cart-empty .blob-btn').forEach(el => {
    el.addEventListener('click', function(e){
      if(getMotion()==='off') return;          // no sound, navigate normally
      const href = el.getAttribute('href');
      if(!href) return;
      e.preventDefault();
      knock();
      setTimeout(()=>{ window.location.href = href; }, 180);
    });
  });
  // checkout button submits the cart form — play the sound, then submit through to Shopify checkout
  document.querySelectorAll('button[name="checkout"]').forEach(btn => {
    btn.addEventListener('click', function(e){
      if(getMotion()==='off' || btn.dataset.knocked) return;   // let the real submit through
      e.preventDefault();
      knock();
      btn.dataset.knocked = '1';
      setTimeout(()=> btn.click(), 175);
    });
  });

  setupGooLayer();
})();